import { Box, Container, Typography } from "@mui/material";
import LandingRichText from "./LandingRichText";
import { checkIfContentEmpty } from "../../utils/tiptap";
import { LANDING_BRAND } from "./landingBrand";

export type CustomLandingSection = {
  badge?: string;
  content?: string;
};

type Props = {
  sections?: CustomLandingSection[];
};

const hasVisibleContent = (section: CustomLandingSection) => {
  if (section.badge?.trim()) {
    return true;
  }
  return Boolean(section.content?.trim() && !checkIfContentEmpty(section.content));
};

const CustomLandingSections = ({ sections }: Props) => {
  const visibleSections = sections?.filter(hasVisibleContent) ?? [];

  if (visibleSections.length === 0) {
    return null;
  }

  return (
    <>
      {visibleSections.map((section, index) => (
        <Box
          key={index}
          component="section"
          sx={{
            py: { xs: 6, md: 8 },
            backgroundColor: index % 2 === 0 ? "#fff" : "#F9FAFB",
          }}
        >
          <Container sx={{
            maxWidth: {
              xs: "100%",
              md: "60%",
            },
          }}>
            <Box sx={{ textAlign: "center" }}>
              {section.badge?.trim() && (
                <Typography
                  variant="body1"
                  fontWeight="regular"
                  sx={{
                    display: "inline-block",
                    mb: 2,
                    p: "4px 16px",
                    borderRadius: 999,
                    bgcolor: LANDING_BRAND.primaryLight,
                    color: LANDING_BRAND.primaryDark,
                    lineHeight: "1.25rem",
                  }}
                >
                  {section.badge}
                </Typography>
              )}
              <LandingRichText
                html={section.content}
                sx={{
                  fontSize: "1.25rem",
                  color: "#4B5563",
                  lineHeight: "1.75rem",
                  // maxWidth: "48rem",
                  mx: "auto",
                  textAlign: "center",
                  "& p": { margin: "0 0 0.75rem", color: "inherit" },
                  "& p:last-child": { marginBottom: 0 },
                  "& ul, & ol": {
                    margin: "0.5rem auto",
                    paddingLeft: "1.5rem",
                    textAlign: "left",
                    display: "inline-block",
                  },
                  "& a": { color: LANDING_BRAND.primaryDark },
                }}
              />
            </Box>
          </Container>
        </Box>
      ))}
    </>
  );
};

export default CustomLandingSections;
